import { Component, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { NewRegisterViewService } from './new.register.view.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { FormGroup } from '@angular/forms';
import { AppService } from '../../app.service';
import { HttpResponse, HttpEventType, HttpHeaderResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { PersonFormService } from '../../PersonComponent/PersonFormComponent/person.form.service';
import { PersonViewService } from '../../PersonComponent/PersonViewComponent/person.view.service';
import { EmployerFormService } from '../../EmployerComponent/EmployerFormComponent/employer.form.service';
import { ProjectViewService } from '../../ProjectComponent/ProjectViewComponent/project.view.service';
import { Countries } from '../../../app/shared/countries/countries';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { ActivatedRoute } from '@angular/router'; 
import { Globals } from '../../globals';
import customerJson from "../../../assets/config/customer.json";
import translateJson from "../../../translate.json";
import { ArchiveModalComponent } from '../../shared/views/ArchiveModalComponent/archive.modal.component';
import { ValidationModalComponent } from '../../shared/views/ValidationModalComponent/validation.modal.component';
import { ErrorModalComponent } from '../../shared/views/ErrorModalComponent/error.modal.component';
import { SuaStatusType } from '../../shared/enum/SuaStatusType';
import { EntityTypes } from '../../shared/enum/EntityTypes';
import { AuthenticationService } from '../../auth';
import { formatDate } from '@angular/common';

enum otherTypeEnum {RK, RKATTACHMENT, WORKFLOW};

@Component({
    selector: 'register-comp',
    providers: [NewRegisterViewService, PersonViewService, ConfirmService, Countries, AppService, PersonFormService, EmployerFormService,NgxSmartModalService, ProjectViewService, AuthenticationService], 
    templateUrl: './new.register.view.component.html',  
    styleUrls: ['../register.component.css']  
})

export class NewRegisterViewComponent {

    @ViewChild('validationModal') validationModal: ValidationModalComponent;
    @ViewChild('errorModalComponent') errorModalComponent: ErrorModalComponent; 
    @ViewChild('archiveModal') archiveModal: ArchiveModalComponent;
    @ViewChild('pdfAttachmentViewer') pdfAttachmentViewer;
    // Get translation/text from translation.json
    private i18 = translateJson.i18;
    // Customer settings
    private customerSettings = customerJson.settings;
    private customerOrgId = customerJson.customer.organisationId;
    rkReceiverActive: Boolean = this.customerSettings.RKReceiver;
    rkShowOperatorAndSupervisor: Boolean = this.customerSettings.rkShowOperatorAndSupervisor;
    rkReceiver: Boolean = this.customerSettings.RKReceiver;
    private globalOrgAssociations: boolean = customerJson.settings.globalOrgAssociations;
    showProjectOperatorInSuaList: Boolean = customerJson.settings.showProjectOperatorInSuaList;
  
    selectedFiles: FileList;
    currentFileUpload: FileLikeObject;
    public uploader: FileUploader = new FileUploader({allowedFileType: ["pdf"]});
    private attachmentContent: any;
    private showContentForAttachment: Boolean = false;

    private activeComponent: boolean;
    private rk;
    showLoader: Boolean = false;
    showAttBody: Boolean = false;
    private person;
    private employer;
    private project;
    private newAttachment: Boolean = false;  
    numOfNotes:number = 0;  

    private restoreRkError = {
        header: this.i18.rk.form.archiveRkRestoreErrorHeader,
        title: this.i18.rk.form.archiveRkRestoreErrorTitle,
        message: this.i18.rk.form.archiveRkRestoreErrorMessage
    }

    testKlass: String = "3";
    nationality: String;
    suaDetailsForm: FormGroup;
    suaCompanyForm: FormGroup;
    extraDatesAvailableForm: FormGroup;
    personDetailsForm: FormGroup;
    id: string;   
    orgAssociationAsString: String;
    suaStatusType = SuaStatusType;
    entityType = EntityTypes;
    edition: String = customerJson.edition;
    employedByCustomer: boolean = false;
    private showRKSecondAttachmentTab: boolean = customerJson.settings.showRKSecondAttachmentTab;
    private xmlExportEnabled: boolean = customerJson.settings.enableDigitalXmlExport;
    private otherType: String = otherTypeEnum[0];
    private sapoWorkflow: any = [];

    pdfBlob: any = null;
    pdfName: string = null;
    currentPdfView: string = '';
    constructor(
        private service: NewRegisterViewService,  
        private personViewService: PersonViewService,
        private ngxSmartModalService: NgxSmartModalService,
        private personService: PersonFormService,
        private sanitizer: DomSanitizer,
        private employerService: EmployerFormService,
        private projectService: ProjectViewService,
        private confirmService: ConfirmService,
        private activatedRoute: ActivatedRoute,
        private location : Location,
        private countries: Countries,
        private appService: AppService,
        private globals: Globals,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated(); 
            this.activeComponent = appService.isComponentActive('registercontrol');
            this.id = this.activatedRoute.snapshot.paramMap.get('id');
            this.setDefault();  
        }

        /**
         * Initiates form
         */
        setDefault() {
            this.getRegisterControl(this.id);
        }

        /**
         * Get a specific RK
         * @param rkId Identifier for RK
         */
        getRegisterControl(rkId) {
            this.service.getRkById(rkId)      
            .subscribe(
                data => this.setDataToRk(data),
                error =>  this.showErrorDialog(this.validationModal.getModalArray()),
                () => this.showLoader = false
            );   
        }

        /**
         * Patch values from retrieved RK
         * @param data Retrieved RK
         */
        setDataToRk(data) {     
            this.rk = data;
            let personSsn: String;
            if(data.placeholderSsn == null || data.placeholderSsn == '') {
                if(data.person.ssn != null && data.person.ssn !== ''){
                    personSsn = data.person.ssn;
                } else if ((this.rk.person.ssn == null || this.rk.person.ssn == '') && this.rk.person.coordinationNumber != null && this.rk.person.coordinationNumber != ''){
                    personSsn = this.rk.person.coordinationNumber;
                } else if((this.rk.person.ssn == null || this.rk.person.ssn == '') && (this.rk.person.coordinationNumber == null || this.rk.person.coordinationNumber == '') && this.rk.person.birthDate != null && this.rk.person.birthDate != '') {
                    personSsn = this.rk.person.birthDate.replaceAll('-', "");
                }
            } else {
                personSsn = data.placeholderSsn
            }
            this.rk.person.ssn = personSsn;
            this.nationality = this.countries.get2CountryCodeName(this.rk.placeholderNationalityCode);
            this.employedByCustomer = this.personIsEmployedByCustomer(this.rk.person);
            this.rk.receiver = this.service.getReceiverById(data.receiverId);
            this.orgAssociationAsString = this.getOrgAssociationAsString(this.rk.orgAssociation);          
            (data.countryOfBirthAbroad != null && data.countryOfBirthAbroad.length > 1) ? this.rk.countryOfBirthAbroad = this.countries.get2CountryCodeName(data.countryOfBirthAbroad) : this.rk.countryOfBirthAbroad = null;
            (this.rk.oldCitizenship != null && this.rk.oldCitizenship.length > 0)? this.rk.oldCitizenship = this.countries.get2CountryCodeNames(this.rk.oldCitizenship) : this.rk.oldCitizenship = null;
            (data.otherAddress != null && data.otherAddress.length > 1) ? this.rk.otherAddress = this.countries.get2CountryCodeName(data.otherAddress) : this.rk.otherAddress = null;
            (data.addressField3 != null && data.addressField3.length > 1) ? this.rk.addressField3 = this.countries.get2CountryCodeName(data.addressField3) : this.rk.addressField3 = null;
            if(data.defaultRkPersonInvestigationAttachment != null){
                data.defaultRkPersonInvestigationAttachment.fellowCountryOfBirthAbroad != null ? this.rk.defaultRkPersonInvestigationAttachment.fellowCountryOfBirthAbroad = this.countries.get2CountryCodeName(data.defaultRkPersonInvestigationAttachment.fellowCountryOfBirthAbroad) : this.rk.defaultRkPersonInvestigationAttachment.fellowCountryOfBirthAbroad = null;
                data.defaultRkPersonInvestigationAttachment.fellowCurrentCitizenship != null ? this.rk.defaultRkPersonInvestigationAttachment.fellowCurrentCitizenship = this.countries.get2CountryCodeName(data.defaultRkPersonInvestigationAttachment.fellowCurrentCitizenship) : this.rk.defaultRkPersonInvestigationAttachment.fellowCurrentCitizenship = null;
                data.defaultRkPersonInvestigationAttachment.fellowOtherCitizenship != null ? this.rk.defaultRkPersonInvestigationAttachment.fellowOtherCitizenship = this.countries.get2CountryCodeName(data.defaultRkPersonInvestigationAttachment.fellowOtherCitizenship) : this.rk.defaultRkPersonInvestigationAttachment.fellowOtherCitizenship = null;
                data.defaultRkPersonInvestigationAttachment.fellowOtherAddressFieldCountry != null ? this.rk.defaultRkPersonInvestigationAttachment.fellowOtherAddressFieldCountry = this.countries.get2CountryCodeName(data.defaultRkPersonInvestigationAttachment.fellowOtherAddressFieldCountry) : this.rk.defaultRkPersonInvestigationAttachment.fellowOtherAddressFieldCountry = null;

            }
            // set the number of notes on first load. this will then be updated when a user adds/removes notes
            this.numOfNotes = this.rk.notes.length;           
        }

        showErrorDialog(modalData) {
            modalData[0] = this.i18.rk.form.showErrorDialog1;
            modalData[1] = this.i18.rk.form.showErrorDialog2;
            this.validationModal.pop();
        }

        back() {
            this.appService.setRoute("/registercontrol");
        }

        editRk() {
            this.appService.setRoute('registercontrol/edit/' + this.rk.id);
        }

        setRoute(route) {
            this.appService.setRoute(route);
        }

        showAttachment() {
            this.ngxSmartModalService.getModal('attachmentModal').open();
        }

        ngAfterViewInit() {
            this.ngxSmartModalService.getModal('attachmentModal').onDismiss.subscribe((modal: NgxSmartModalComponent) => {
                // modal is the dismissed modal, so do what you want with it
                this.resetModal();
            });
        }

        resetModal() {
            this.newAttachment = false;
            this.showAttBody = false;
            this.uploader.clearQueue();
        }

        showAttachmentBody() {
            this.showAttBody = true;
        }

        selectFile(event) {
            this.selectedFiles = event.target.files;
        }

        showUploader() {
            this.newAttachment = true;
        }

        getFiles(): FileLikeObject[] {
            return this.uploader.queue.map((fileItem) => {
                return fileItem.file;
            });
        }

        upload() {
            let files = this.getFiles();

            for(let i=0; i < files.length; i++) {
                let formData = new FormData();
                formData.append('file', files[i].rawFile, files[i].name);
                this.personViewService.upload(formData).subscribe(event => {
                    if(event.status != 200) {
                        return;
                    }
                    if(event instanceof HttpResponse) {
                        let defaultRkAttachment = {
                            readableName: files[i].name,
                            uploadedDate: null,
                            attachmentType: "defaultRkAttachment"
                          }
                          this.personViewService.saveAttachment(defaultRkAttachment, "default-rk", this.rk.id).subscribe(
                            data => this.uploadReady(),
                            error => console.log(error)
                        )
                    }
                })
            }
        }

        /**
         * Set's a pdf blob to be previewed upon user request
         * @param data pdf to view as blob
         * @param filename readable name of pdf file
         * @param elementId id of html elemet that triggered the preview
         */
        renderAttachment(data, filename, elementId) {
            this.currentPdfView = elementId;
            this.pdfName = filename;
            this.pdfBlob = new File([(data)], filename, {type: 'application/pdf'});
            if(this.pdfAttachmentViewer != undefined && this.pdfAttachmentViewer != null) {
            this.pdfAttachmentViewer.pdfSrc = this.pdfBlob;
            this.pdfAttachmentViewer.refresh();
            }
            this.showContentForAttachment = true;
        }

        /**
         * Closes the latest pdf preview 
         */
        clearPreview() {
            this.currentPdfView = '';
            this.pdfBlob=null;
            this.pdfName=null;
            this.attachmentContent = null;
            this.showContentForAttachment = false;    
        }

        sanitizeUrl(url) {
            this.attachmentContent = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            this.showContentForAttachment = true;
        }

        showAttachedFile(id, filename, elementId) {
            this.personViewService.showAttachedFile(id).subscribe(
                data => this.renderAttachment(data, filename, elementId),
                error => console.log(error)
            );
        }

        uploadReady() {
            this.getRegisterControl(this.id);
            this.uploader.clearQueue();
            this.newAttachment = false;
        }

        archiveRk() {
            // Setup entity
            let entityObject = this.archiveModal.createEntityObject(this.entityType.RK, this.id,[]);

            // Setup entity and prepare to show modal
            this.archiveModal.setEntityData(entityObject);

            // Display modal
            this.archiveModal.pop()
        }

        /**
         * Report an existing registercontrol
         */
        reportRk() {
            this.confirmService.confirm(this.i18.rk.modal.rkConfirmReportRegistercontrol)
                .then(result => {
                    if(result) {
                        this.service.reportRegisterControl(this.id, this.suaStatusType.REPORT)
                            .subscribe(
                                data => this.getRegisterControl(this.id),
                                error => this.showErrorModal(this.errorModalComponent.getErrorModalArray(), error)
                            )
                    }
                });
        }

        /**
         * Delete a attachment
         * @param attachmentId uuid of attachment
         * @param attachmentName name of attachment
         */
        deleteAttachment(attachmentId, attachmentName){
            this.confirmService.confirm(this.i18.rk.form.confirmDeleteOfAttachement + ' ' + attachmentName)
                .then(result => {
                    if(result) {
                        this.service.deleteAttachment(attachmentId, this.id)
                            .subscribe(
                                data => this.getRegisterControl(this.id),
                                error => this.showErrorModal(this.errorModalComponent.getErrorModalArray(), error)
                            )
                    }
                });
        }

        /**
         * Show error modal
         * @param modalData modalData array
         * @param error error msg
         */
        showErrorModal(modalData, error) {
            modalData[0] = error.header;
            modalData[1] = error.title;
            modalData[2] = error.message;
            this.errorModalComponent.pop();
        }

        /**
         * Show error thrown when editing notes
         * @param error error text
         */
        showNoteError(error) {
            this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
        }

        /**
         * Returns a string representation of a person's organisational association as
         * "Department - Entity - Section."
         * @param orgAssociation An organisational association.
         */
         getOrgAssociationAsString(orgAssociation: any): String {
            if (!orgAssociation) {
                return '';
            }
            return `${orgAssociation.department} - ${orgAssociation.entity} - ${orgAssociation.section}`
        }

        /**
         * Check if the customer organisation ID exist on one of the person's employers.
         * @param person Person entity.
         */
        personIsEmployedByCustomer(person: any): boolean {
            return person.employers.find(employer => employer.organisationId === this.customerOrgId) ? true : false;
        }
        /**
     * unarchive a project
     * @param projectId projectid to restore
     */
    restoreArchivedDefaultProject(rkId){
        if(this.rk.person.deleted) {
            this.restoreRkError.message = this.i18.rk.form.restoreArchivedDefaultProject1;
            this.showErrorModal(this.errorModalComponent.getErrorModalArray(), this.restoreRkError);
        } else if(this.rk.project != null && this.rk.project.archived) {
            this.restoreRkError.message = this.i18.rk.form.restoreArchivedDefaultProject2;
            this.showErrorModal(this.errorModalComponent.getErrorModalArray(), this.restoreRkError);
        } else {
            this.confirmService.confirm(this.i18.rk.form.confirmRestoreRegistercontrol)
                .then(result => {
                    if(result){
                        this.service.archiveRegisterControl(rkId)
                            .subscribe(
                                data => this.setDefault(),
                                error => console.log(error)
                    )}
                });
        }
    }

    /**
   * Set other type
   * @param type type of page
   */
    setOtherType(type:number) {
        this.otherType = otherTypeEnum[type];

        if (type == 2) {
            this.getSapoWorkflow();
        }
    }

    /**
     * This method will call for service in order to retrieve workflow by type
     * and then call setSapoWorkflow()
     */
    public getSapoWorkflow() {    
        this.service.getSapoWorkflow()
            .subscribe(
                data => this.setSapoWorkflow(data),
                error => console.log(error)
            );      
    }

    /**
     * This method will set the RK workflow 
     */
    public setSapoWorkflow(workflow) {        
        this.sapoWorkflow = workflow;        
        var rkWorkflow = this.rk.sapoWorkflowList;        
        for(let i=0; i < this.sapoWorkflow.length; i++) { 
            this.sapoWorkflow[i].active = false;
            this.sapoWorkflow[i].swDate = null;
            this.sapoWorkflow[i].translatedName = this.appService.getTranslateValueFromKeyStr(this.sapoWorkflow[i].i18, this.sapoWorkflow[i].readableName);

            for(let j=0; j < rkWorkflow.length; j++) {
                if(rkWorkflow[j].swId == this.sapoWorkflow[i].id) {                    
                    this.sapoWorkflow[i].active = rkWorkflow[j].active;
                    this.sapoWorkflow[i].swDate = formatDate( rkWorkflow[j].swDate, 'yyyy-MM-dd', 'en') ;
                }
            }             
        }       
    }

    /**
     * Anchor
     * @param target id
     */
    public anchor(target): void {
        this.appService.scrollToTarget(target);
    }

    /**
     * Helper to update the number of notes displayed on top of the page.
     * Checks if the value from the notes component is a number and updates it.
     * If the value is not a number the amount of notes is taken from the notes array received in the initial request.
     * @param numOfNotes 
     */
     setNumOfNotes(numOfNotes: number){
        if(numOfNotes != null && !Number.isNaN(numOfNotes)){
            this.numOfNotes = numOfNotes;
        } else {
            this.numOfNotes = this.rk.notes.length;
        }
    }
}